import React, { useMemo } from 'react';
import { TimeSeriesLineChart } from '@/components/visuals';
import type { ChartDensity } from '@/components/visuals';

export interface LogicIntegrityTrendChartProps {
  xAxisData: string[];
  missingPred: number[];
  missingSucc: number[];
  constrained: number[];
  outOfSequence: number[];
  height?: number | string;
  showDataLabels: boolean;
  density?: ChartDensity;
}

export function LogicIntegrityTrendChart({
  xAxisData,
  missingPred,
  missingSucc,
  constrained,
  outOfSequence,
  height = 260,
  showDataLabels = true,
  density = 'overview',
}: LogicIntegrityTrendChartProps) {
  const series = useMemo(
    () => [
      { name: 'Missing pred', data: missingPred },
      { name: 'Missing succ', data: missingSucc },
      { name: 'Constrained', data: constrained },
      { name: 'OOS', data: outOfSequence },
    ],
    [missingPred, missingSucc, constrained, outOfSequence]
  );
  return (
    <TimeSeriesLineChart
      xAxisData={xAxisData}
      series={series}
      height={height}
      showDataLabels={showDataLabels}
      density={density}
    />
  );
}
